export default __webpack_public_path__ + "static/media/print_estimate_1.84585059.svg";